<template>
    <div class="a-modal">
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ $lang('statisticModal.title') }}</span>
        </div>
        <div class="popup__content popup__content--pt-small popup__content--pb-big">
            <form class="form" ref="form">
                <div class="a-filters__item">
                    <span id="end" class="form__label">{{ $lang('statisticModal.period') }}</span>
                    <date-interval id="start" slot="reference" v-model="filters" :errors-notifier="errors"/>
                </div>
                <span class="form__label">{{ $lang('title10') }}</span>
                <el-select filterable
                           slot="reference"
                           class="input"
                           :disabled="partnerIds.length === 0"
                           :loading-text="$lang('el-select.loading')"
                           :noDataText="$lang('el-select.noDataText')"
                           :noMatchText="$lang('el-select.noMatchText')"
                           v-model="filters.partnerIds"
                           multiple
                           collapse-tags
                           required>
                    <el-option key="all" value="all" :label="$lang('statisticModal.label3.selectLabel')"></el-option>
                    <el-option v-for="item in partnerIds"
                               :key="item.id"
                               :value="item.user_id"
                               :label="item.user.name">
                    </el-option>
                </el-select>
            </form>
        </div>
        <div class="popup__footer">
            <div>
                <button
                    class="btn btn--middle btn--main-bg"
                    style="margin-right: 10px; margin-bottom: 10px;"
                    @click.prevent="send()">{{ $lang('statisticModal.button') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../../api/api";
import errors from "../../../mixins/errors";
import validator from "../../../mixins/validator";
import DateInterval from "../../../components/DateInterval";
import Vue from "vue";

export default {
    name: "StatisticModalPartner",
    mixins: [errors, validator],
    components: {DateInterval},
    data() {
        return {
            filters: {
                start: '',
                end: '',
                partnerIds: ['all'],
            },
            partnerIds: [],
            partnerId: null,
            errors: {
                start: {isError: false, message: ''},
                end:  {isError: false, message: ''},
            },
            rules: {
                start: [
                    {required: true, message: Vue.prototype.$lang('statisticModal.start')},
                ],
                end: [
                    {required: true, message: Vue.prototype.$lang('statisticModal.end')},
                ]
            },
        }
    },
    watch: {
        filters: {
            handler() {
                this.clearErrors();
            },
            deep: true
        },
        'filters.partnerIds': {
            handler(partnerIds, old) {
                let selected = partnerIds.filter(partnerId => !old.includes(partnerId));

                if (selected.length > 0) {
                    if (selected[0] === 'all') {
                        this.filters.partnerIds = ['all'];
                    } else {
                        this.filters.partnerIds = partnerIds.filter(partnerId => partnerId !== 'all');
                    }
                }
            },
            deep: true
        }
    },
    mounted() {
        ApiService.get('/partners-list')
            .then((response) => {
                this.partnerIds = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        send() {
            this.validate(() => {
                this.$loading(this.$optionsLoading);

                ApiService.post('/partner/send-admin-statistic', {filters: this.filters})
                    .then(() => {
                        this.$appNotify.success(Vue.prototype.$lang('statisticModal.success'));
                    })
                    .finally(() => {
                        this.$loading({}).close();
                    })
                    .catch(() => {
                        this.$appNotify.error('Ошибка');
                    });
            }, {...this.filters});
        },
    },
}
</script>
